import { Component, Input } from '@angular/core';

import { IBreadcrumb } from '../breadcumb/IBreadcrumb';

@Component({
    selector: 'btl-pre-footer',
    templateUrl: './pre-footer.component.html',
    styleUrls: ['./pre-footer.component.scss'],
})
export class PreFooterComponent {
    public isLegals: boolean = false;
    @Input() public blockId: string;
    @Input() public isBattlefront: boolean = true;
    @Input() public isBta: boolean = false;
    @Input() public paramToAdd: IBreadcrumb[] = [];
    @Input() public additionalBlockId: string;

    public toggleLegals(): void {
        this.isLegals = !this.isLegals;
    }
}
